/* eslint-disable react-hooks/exhaustive-deps */

import React, {cloneElement, useCallback, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {useQuery} from "@apollo/react-hooks";
import {Route, Switch, useHistory, useParams, useRouteMatch} from "react-router-dom";
import {GET_TEAM_MEMBERSHIPS} from "../../database/queries/teamQueries";
import {GET_INTEGRATIONS} from "../../database/queries/integrationQueries";
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import {SizeMe} from "react-sizeme";
import useLayoutStore from "../../layoutStore";
import ConfirmationDialog from "../../dialogs/confirmation";
import usePersistentStore from "../../persistentStore";
import Select from "@material-ui/core/Select";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import MenuItem from "@material-ui/core/MenuItem";

const useStyles = makeStyles(theme => ({
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
        minHeight: 24,
        '& .MuiTab-root': {
            minHeight: 24,
        }
    },
    toolbar: {
        '& .MuiToolbar-dense': {
            minHeight: 24,
        }
    },
    stifle: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
        width: '100%',
        textAlign: 'left',
        fontSize: '90%'
    },
    tabPanel: {
        width: '100%'
    },
    noMargin: {
        marginBottom: 0,
        minHeight: 0
    },
    gridNoPadding: {
        padding: 0,
        margin: 0
    },
    leftColumn: {
        padding: 0,
        margin: 0,
    },
    boxNoPadding: {
        padding: 0,
        margin: 0
    },
    selectedTab: {
        border: '1px solid #108FC0',
    },
    tab: {}
}));

function TabPanel(props) {
    const classes = useStyles();
    const {children, value, index, ...other} = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            className={classes.tabPanel}
            {...other}
        >
            {value === index && <Box p={1} m={0}>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

const INITIAL_SHARES = [
    {
        shareCategoryType: 'personal',
        shareCategoryId: 'personal',
        shareCategoryName: 'Personal',
        icon: <PersonOutlineIcon style={{verticalAlign: 'middle'}}/>
    },
];

const INITIAL_DIALOG = {
    title: "Stop Editing",
    question: 'Are you sure you want to stop editing?',
    yesHandler: null,
    noHandler: null,
};

const ShareSelect = (props) => {
    const classes = useStyles();
    const [choice, setChoice] = useState(0);
    const [shares, setShares] = useState([...INITIAL_SHARES]);
    const [globalPersistentState, globalPersistentActions] = usePersistentStore();
    // eslint-disable-next-line no-unused-vars
    const [globalLayoutState, globalLayoutActions] = useLayoutStore();
    const [teams, setTeams] = useState([]);
    const [integrations, setIntegrations] = useState([]);
    const [confirmation, setConfirmation] = useState(INITIAL_DIALOG);
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    let {url} = useRouteMatch();
    const {shareCategoryType, shareCategoryId} = useParams();
    const history = useHistory();

    const {data: dataTeams} = useQuery(GET_TEAM_MEMBERSHIPS, {
        variables: {
            orderList: ['teamName ASC']
        },
    });

    const {data: dataIntegrations} = useQuery(GET_INTEGRATIONS, {
        variables: {
            orderList: ['integrationName ASC']
        },
    });

    const sortCompare = (a, b) => {
        if (a.shareCategoryId === 'personal') {
            return -1
        } else if (b.shareCategoryId === 'personal') {
            return 1
        } else if (a.shareCategoryName < b.shareCategoryName) {
            return -1;
        } else if (a.shareCategoryName > b.shareCategoryName) {
            return 1;
        } else {
            return 0;
        }
    };

    useEffect(() => {
        for (let s = 0; s < shares.length; s++) {
            if (shares[s].shareCategoryType === shareCategoryType && shares[s].shareCategoryId === shareCategoryId) {
                if (choice !== s) setChoice(s);
                break;
            }
        }
    }, [shares])

    useEffect(() => {
        if (dataTeams && dataTeams.teamMemberships) {
            let fetchedTeams = [];
            for (let t = 0; t < dataTeams.teamMemberships.length; t++) {
                const team = dataTeams.teamMemberships[t];
                fetchedTeams.push({
                    shareCategoryType: 'team',
                    shareCategoryId: team.teamId,
                    shareCategoryName: team.teamName,
                    icon: <PeopleOutlineIcon style={{verticalAlign: 'middle'}}/>
                });
            }
            setTeams(fetchedTeams);
        }
    }, [dataTeams]);

    useEffect(() => {
        if (dataIntegrations && dataIntegrations.integrations) {
            let fetchedIntegrations = [];
            for (let i = 0; i < dataIntegrations.integrations.length; i++) {
                const integration = dataIntegrations.integrations[i];
                fetchedIntegrations.push({
                    shareCategoryType: 'integration',
                    shareCategoryId: integration.integrationId,
                    shareCategoryName: integration.integrationName,
                    icon: <SupervisedUserCircleIcon style={{verticalAlign: 'middle'}}/>
                });
            }
            setIntegrations(fetchedIntegrations);
        }
    }, [dataIntegrations]);

    useEffect(() => {
        let merged = [...INITIAL_SHARES].concat(teams, integrations).sort(sortCompare);
        setShares(merged);
    }, [teams, integrations]);

    useEffect(() => {
        const path = `${url}/${shares[choice].shareCategoryType}/${shares[choice].shareCategoryId}`;
        console.log('## SVR shareSelect ## changing history', path);
        history.push(path);
    }, [choice])

    const shouldChangeTabs = (objName, callback) => {
        let leftOver = null;
        if (globalPersistentState[objName]) leftOver = objName;

        if (globalPersistentState.dirty && leftOver) {
            setConfirmation({
                ...INITIAL_DIALOG,
                question: 'Are you sure you want to stop editing the ' + leftOver + '?',
                yesHandler: () => {
                    globalPersistentActions.clearBiggie(objName);
                    if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
                    setConfirmationOpen(false);
                    callback(true);
                },
                noHandler: () => {
                    setConfirmationOpen(false);
                    callback(false);
                },
            });
            setConfirmationOpen(true);
        } else {
            if (objName) globalPersistentActions.clearBiggie(objName);
            if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
            callback(true);
        }
    };

    const handleChange = (e) => {
        shouldChangeTabs(props.shareParent, (yesIShould) => {
            if (yesIShould) {
                setChoice(e.target.value);
            }
        });
    };

    const setMyHeight = () => {
        const ssb = document.getElementById('shareSelectBar');
        if (ssb) globalLayoutActions.setShareSelectBarHeight(ssb.clientHeight);
    };

    const rectCallbackRef = useCallback(node => {
        setMyHeight();
    }, []);

    return (
        <div>
            {shares && (
                <div className={classes.shares}>
                    <SizeMe>
                        {({size}) => {
                            let height = size.height;
                            if (!height) height = window.innerHeight;
                            // let otherStuffHeight = 220;
                            // if (inIFrame) otherStuffHeight = 30;
                            // const newTabHeight = height - (globalLayoutState.headerHeight + globalLayoutState.tabBarHeight + otherStuffHeight);

                            return (
                                <div>
                                    <AppBar id="shareSelectBar" ref={rectCallbackRef} position="static" color={props.color ? props.color : 'default'}
                                            className={classes.toolbar}>
                                        <Toolbar variant="dense" className={classes.toolbar}>
                                            <Select
                                                required
                                                id="parentType"
                                                name="parentType"
                                                labelid="label-share"
                                                size="small"
                                                value={choice}
                                                onChange={handleChange}
                                            >
                                                {shares.map((share, idx) => {
                                                    return (
                                                        <MenuItem
                                                            key={idx}
                                                            value={idx}>
                                                            {share.shareCategoryName}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Select>
                                            <Typography>{props.parent.title}{props.editObj ? ' for ' + props.editObj.displayName : ''}</Typography>
                                        </Toolbar>
                                    </AppBar>
                                    <Switch>
                                        <Route
                                            path={`${url}/${shares[choice].shareCategoryType}/${shares[choice].shareCategoryId}`}>
                                            {cloneElement(props.parent.component, {
                                                ...props,
                                                shareCategoryType: shares[choice].shareCategoryType,
                                                shareCategoryId: shares[choice].shareCategoryId,
                                                shareCategoryName: shares[choice].shareCategoryName
                                            })}
                                        </Route>
                                    </Switch>
                                </div>
                            )
                        }}
                    </SizeMe>
                </div>
            )}
            <ConfirmationDialog
                open={confirmationOpen}
                title={confirmation.title}
                question={confirmation.question}
                handleYes={confirmation.yesHandler}
                handleNo={confirmation.noHandler}
            />
        </div>
    );
};

export default ShareSelect;
